/**
 * Opciones de aliado para el filtro del listado de Clientes (US-2.3).
 *
 * El filtro `aliadoId` del listado es efectivo solo para `SUPER_ADMIN` (contrato) y
 * `ALIADO_ADMIN` no puede listar aliados. Por eso la carga se activa con `enabled`:
 * así no se dispara un 403 innecesario para los roles que no usan las opciones. El
 * alta de cliente ya no elige aliado (la relación se deriva de la actividad, ADR 0049).
 */
import { useEffect, useState } from 'react';
import type { AllySummary } from '@goelectric/shared-types';
import { allyApi } from '@/features/aliados/api/allyApi';

/**
 * Tope de aliados traídos para el selector. El contrato de aliados no expone un
 * endpoint de "todos"; se piden los primeros 100 (mismo criterio que `LocationsListPage`).
 */
export const ALLY_FILTER_OPTIONS_LIMIT = 100;

export function useAllyFilterOptions(enabled: boolean): AllySummary[] {
  const [allies, setAllies] = useState<AllySummary[]>([]);

  useEffect(() => {
    if (!enabled) {
      setAllies([]);
      return;
    }

    let cancelled = false;
    allyApi
      .list({ limit: ALLY_FILTER_OPTIONS_LIMIT })
      .then((page) => {
        if (!cancelled) setAllies(page.data);
      })
      .catch(() => {
        // El selector es un auxiliar: si falla, se degrada a "sin opciones" sin
        // romper el listado de clientes (el filtro queda vacío).
        if (!cancelled) setAllies([]);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return allies;
}
